import React from 'react';
import presidentPic from './president.jpeg'; 

const PresidentProfile = () => {
  return (
    <section className="card shadow-sm border-0 mb-5" style={{ borderRadius: '1rem', overflow: 'hidden' }}>
      <div className="row g-0">
        
        {/* Left Side: Photo Area */}
        <div className="col-md-4 d-flex justify-content-center align-items-center p-5" style={{ backgroundColor: '#f8fafc', borderRight: '1px solid #e2e8f0' }}>
          <div className="position-relative">
            <img 
              src={presidentPic} 
              alt="Mr. Vinod Kumar" 
              className="rounded-circle shadow"
              style={{ width: '220px', height: '220px', objectFit: 'cover', border: '6px solid #1e293b' }}
            />
            
            {/* 🔴 Yahan par quote icon ki jagah 'President' ka stylish badge laga diya gaya hai */}
            <div 
              className="position-absolute shadow-sm rounded-pill d-flex align-items-center justify-content-center text-white px-4 py-1"
              style={{ backgroundColor: '#0284c7', bottom: '0px', left: '50%', transform: 'translateX(-50%)', border: '3px solid #f8fafc' }}
            >
              <span className="fw-bold text-uppercase" style={{ fontSize: '0.8rem', letterSpacing: '1px' }}>President</span>
            </div>

          </div>
        </div>
        
        {/* Right Side: Message Content */}
        <div className="col-md-8 p-4 p-md-5 d-flex flex-column justify-content-center">
          <span className="text-uppercase fw-bold mb-2" style={{ color: '#0284c7', fontSize: '0.85rem', letterSpacing: '2px' }}>
            President's Message
          </span>
          <h2 className="fw-bolder mb-1" style={{ color: '#1e293b' }}>Mr. Vinod Kumar</h2>
          <h5 className="mb-4 text-muted fw-normal fs-6">Founder, Jairaji Educational Trust</h5>
          
          <div className="pe-lg-4">
            <p className="text-muted mb-3" style={{ lineHeight: '1.8', fontSize: '1.05rem' }}>
              "Welcome to Jairaji Educational Trust. Our core philosophy is rooted in the belief that education and practical skills are the most powerful tools for social transformation. We are deeply committed to bridging the opportunity gap for individuals residing in rural areas."
            </p>
            <p className="text-muted mb-0" style={{ lineHeight: '1.8', fontSize: '1.05rem' }}>
              "By delivering high-quality training across vital sectors—including <strong>Healthcare, Apparel, IT, Automotive, Agriculture, Aviation, and Retail</strong>—our mission is to foster self-reliance. We don't just train candidates; we empower them to secure sustainable livelihoods, uplift their families, and contribute meaningfully to the nation's growth."
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default PresidentProfile;